import { memo } from 'react';
import type { NodeProps } from 'reactflow';
import { Shield, ShieldCheck } from 'lucide-react';
import { BaseNodeUI } from './BaseNodeUI';

const BarrierNode = ({ selected }: NodeProps) => {
    return (
        <BaseNodeUI
            title="Sync Barrier"
            icon={Shield}
            colorClass=""
            bgClass="bg-orange-100/50 hover:border-orange-300"
            selected={selected}
            isSource={true}
            isTarget={true}
        >
            {/* Optional Decoration */}
            <div className="absolute -top-1.5 -right-1 z-0 opacity-20 text-orange-400 pointer-events-none">
                <ShieldCheck size={24} />
            </div>
        </BaseNodeUI>
    );
};

export default memo(BarrierNode);
